import React from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import 'videojs-hotkeys';

import LockedVideo from '../videoComponents/LockedVideo';

import '../../css/player.css';


class SimpleVideoPlayer extends React.Component {
  constructor(props) {
    super(props);
  }

  playButton = () => {
    if (this.player) {
      this.player.play().catch();
    }
  };

  initVideoJs = () => {
    const { clip } = this.props.audition;
    const { clipUrls, defaultClipUrl } = clip || {};

    if (!clipUrls && !defaultClipUrl) {
      return;
    }


    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      this.hotkeys({
        volumeStep: 0.1,
        seekStep: 10,
        captureDocumentHotkeys: false,
        documentHotkeysFocusElementFilter: e => e.tagName.toLowerCase() === 'body',
    });
      const clipUrl = clipUrls ? clipUrls.SIZE_720 : undefined;
      const src = clipUrl || defaultClipUrl;

      if (src) {
        this.src(src);
      }
    });
  };

  componentDidMount() {
    this.initVideoJs();
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    const { audition } = this.props;

    const videoAvailable = audition.clip.clipUrls || audition.clip.defaultClipUrl;

    return (
      <div className="masthead ">
        {videoAvailable ? <div className="container">
          <div className="clearfix video-player-container preview" id="video-player-container">
            <div className="full-player">
              <div className="player-zone">
                <div className="video-player">
                  <div id="vp_18">
                    <div className="sk-video-player" id="vp_18_wrapper">
                      <video
                        ref={(node) => this.videoNode = node}
                        className="video-js vjs-sk vjs-default-skin vjs-paused vp_18_video-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v6 vjs-user-active"
                        controls={true}
                        id="vp_18_video_html5_api"
                        playinline=""
                        poster={audition.clip.imageUrl}
                        preload="none"
                        tabIndex="-1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> : <LockedVideo
          customBackgroundColor="inherit"
          slug={audition.slug}
          videoElement={{ imageUrl: audition.clip ? audition.clip.imageUrl : '' }}
        />}
      </div>
    );
  }
}

export default SimpleVideoPlayer;
